import './App.css';
import { createContext, useReducer } from 'react';
import { motion } from 'framer-motion';
import styled, { keyframes } from 'styled-components';
import logo from './assets/logo.svg';
import { useEffect, useMemo, useState } from 'react';
import * as anchor from '@project-serum/anchor';
import Home from './Home';
import { DEFAULT_TIMEOUT } from './connection';
import { clusterApiUrl } from '@solana/web3.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from '@solana/wallet-adapter-wallets';

import {
  ConnectionProvider,
  WalletProvider,
} from '@solana/wallet-adapter-react';
import { WalletDialogProvider } from '@solana/wallet-adapter-material-ui';

import { ThemeProvider, createTheme } from '@material-ui/core';
require('@solana/wallet-adapter-react-ui/styles.css')

const theme = createTheme({
  palette: {
    type: 'dark',
  },
});

const getCandyMachineId = (): anchor.web3.PublicKey | undefined => {
  try {
    const candyMachineId = new anchor.web3.PublicKey(
      process.env.REACT_APP_CANDY_MACHINE_ID!,
    );

    return candyMachineId;
  } catch (e) {
    console.log('Failed to construct CandyMachineId', e);
    return undefined;
  }
};

const candyMachineId = getCandyMachineId();
const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;
const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(
  rpcHost ? rpcHost : anchor.web3.clusterApiUrl('devnet'),
);

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSlopeWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    [],
  );
  {/* window.addEventListener('load', () => {
    setTimeout(() => {
      setLoaded(true);
    }, 2000)
    setTimeout(() => {
      setHideBg(true);
    },5000)
    setShowCurtain(true);
  })
  const curtainAnimation = keyframes`
    0% {
      transform: scale(1);
      height: 15vw;
      width: 15%;
      opacity: 1;
    }
    25% {
      transform: scale(100);
    }
    50% {
      height: 100vh;
      width: 100%;
      border-radius: 0%;
      bottom: 0px;
      clip-path: polygon(0 0, 100% 20%, 100% 100%, 0% 100%);
    }
    100% {
      bottom: 0px;
      width: 100%;
      height: 0vh;
      border-radius: 0%;
      clip-path: polygon(0 0, 100% 60%, 100% 100%, 0% 100%);
    }
  `;

  const HideBackground = keyframes`
    0% {
      background-color: var(--primary-background);
    }
    100% {
      background-color: transparent;
    }
  `;

  const Curtain = styled.div`
    background-color: var(--connect-wallet);
    border-radius: 50%;
    width: 0%;
    height: 0vw;
    opacity: 1;
    z-index: 80;
    position: absolute;
    animation: ${curtainAnimation} 3s ease-out;
  `;

  const PreloadDone = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: transparent;
    pointer-events: none;
    align-items: center;
    display: flex;
    justify-content: center;
    animation: ${HideBackground} 1s ease-out;
  `;

  const [ loaded, setLoaded ] = useState(false);
  const [ hideBg, setHideBg ] = useState(false);
  const [ showCurtain, setShowCurtain ] = useState(false); */}

  return (
    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletDialogProvider>
            <Home
              candyMachineId={candyMachineId}
              connection={connection}
              txTimeout={DEFAULT_TIMEOUT}
              rpcHost={rpcHost}
              network={network}
            />
            {/* loaded ? showCurtain ? hideBg ? '' : ((
              <PreloadDone>
                <Curtain />
            </PreloadDone>)
            ) : ''
              
            : ( 
              <div className='preload'>
                <img className='logo-black' src={logo} alt="logo" />
                <div className="color-logo">
                  <div className='color-innerDiv'>
                    <img src={logo} alt="logo-color" />
                    <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" className="wave"><defs></defs><path id="feel-the-wave" d=""/></svg>
                  </div>
                </div>
            </div> */}
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
    </ThemeProvider>
  );
};

export default App;
